const COOKIE_LIST = ["token", "ToctocCookie"];

export const getCookieListToctoc = (): string[] => COOKIE_LIST;

export const setCookie = (cookieName: string, cookieValue: string, seconds: number) => {
	if(!document || document.cookie === undefined) return undefined;

	const expires = new Date();
	expires.setTime(expires.getTime() + (seconds * 1000));
	document.cookie = `${cookieName}=${cookieValue}; expires=${expires.toUTCString()}; path=/`;
}